<template>
    <div :class="{
            'update-web': true,
            'update-mobile': $detect == 'mobile'
        }">
        <div class="row">
            <div :class="{
                    'col-6 pr-2': $detect == 'web',
                    'col-12 p-0': $detect == 'mobile'
                    }">
                <div class="card-dashboard">
                    <div class="title-card">
                        <div class="d-flex justify-content-between">
                            <div class="py-10px px-3">Hình ảnh</div>
                            <div class="noti-picture text-secondary fs-12px">
                                * Click vào ảnh để thay đổi ảnh chính
                            </div>
                        </div>
                    </div>
                    <div class="body-card-auto">
                        <div class="info-picture vg-scrollbar px-2">
                            <div :class="{
                                    'd-flex flex-wrap pb-3' : $detect == 'web',
                                    'd-flex flex-nowrap py-3 img-flex' : $detect == 'mobile'
                                }">
                                <div class="upload-img text-center">
                                    <div class="btn-upload" role="button" @click="upload()">
                                        <i class="icon ion-md-cloud-upload"></i>
                                        <p class="mb-0 fs-14px">
                                            Tải ảnh lên
                                        </p>
                                    </div>
                                </div>
                                <input type="file" v-show="false" multiple class="input-upload" @change="changeImage"/>
                                <div class="img position-relative" role="button" v-for="(item) in previewImg" :key="item.id">
                                    <img class="w-100 h-100" :src="item.url"/>
                                    <div class="loading-img position-absolute d-flex justify-content-center align-items-center">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="img position-relative" role="button" v-for="(item, index) in form.picture" :key="index">
                                    <img class="w-100 h-100" :src="item.url" @click="form.picture.length > 1 ? selectPictureMain(item) : ''"/>
                                    <div class="delete-img position-absolute" @click="destroy(item, index)" v-if="form.picture.length > 1">
                                        <i class="icon ion-ios-close"></i>
                                    </div>
                                    <div class="checked-img position-absolute text-center" v-if="item.name == form.detail.picture_main">
                                        <div class="btn-check text-center">
                                            <i class="icon ion-md-checkmark mr-1 fs-12px"></i>
                                            <span class="fs-12px">Ảnh chính</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="{
                    'col-6 pl-2': $detect == 'web',
                    'col-12 p-0': $detect == 'mobile'
                    }">
                <div class="card-dashboard">
                    <div class="title-card">
                        <div class="d-flex justify-content-between">
                            <div class="py-10px px-3">Thông tin</div>
                            <div class="btn-update" role="button" @click="updateCheck = 1" v-if="!(this.form.status == 1 && this.form.status_expire === 0)">
                                <i class="icon ion-md-create mr-2"></i>Chỉnh sửa
                            </div>
                        </div>
                    </div>
                    <div class="body-card-auto">
                        <div class="info-post p-3 fs-14px">
                            <div class="d-flex">
                                <div class="w-title">Sản phẩm:</div>
                                <div class="w-value"><p class="mb-0 name-category">{{ getForm.name }}</p></div>
                            </div>
                             <div class="d-flex mt-3">
                                <div class="w-title">Mã SKU:</div>
                                <div class="w-value">{{getForm.sku}}</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Giá:</div>
                                <div class="w-value fw-600 text-danger">{{ getForm.price_convert || getForm.price }} vnđ</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Thuế:</div>
                                <div class="w-value">{{ getForm.vat == 1 ? 'Vat' : 'Không Vat'}}</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Số lượng tối thiểu bán ra:</div>
                                <div class="w-value">{{ getForm.min_quality }}</div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Bảo hành:</div>
                                <div class="w-value">
                                    {{getForm.warranty}} tháng
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Nguồn gốc:</div>
                                <div class="w-value">
                                    {{ type[getForm.type] }}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Xuất xứ:</div>
                                <div class="w-value" v-if="getForm.origin <= 0">
                                    {{ nation[getForm.origin] && nation[getForm.origin]['n_name'] ? nation[getForm.origin]['n_name'] : 'Đang cập nhật' }}
                                </div>
                                <div class="w-value" v-else>
                                    {{ nation[getForm.origin] && nation[getForm.origin]['n_name'] ? nation[getForm.origin-1]['n_name'] : 'Đang cập nhật' }}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Trạng thái:</div>
                                <div class="w-value">
                                    {{getForm.quality == 0 ? 'Hàng mới' : 'Hàng cũ'}}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Tùy chọn:</div>
                                <div class="w-value">
                                    {{ getForm.hot == 1 ? 'Nổi bật' : '' }}
                                    {{ getForm.new == 1 && getForm.hot == 1 ? ' - ' : '' }}
                                    {{ getForm.new == 1 ? 'Mới' : '' }}
                                    {{ getForm.promotion == 1 && getForm.new == 1 ? ' - ' : '' }}
                                    {{ getForm.promotion == 1 ? 'Khuyến mãi' : '' }}
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Hiển thị nút:</div>
                                <div class="w-value">
                                    <span v-if="getForm.quantity == 0" class="btn_rdo btn_rdo_call">Gọi điện</span>
                                    <span v-else class="btn_rdo btn_rdo_buy">Đặt mua</span>
                                </div>
                            </div>
                            <div class="d-flex mt-3">
                                <div class="w-title">Website:</div>
                                <div class="w-value">{{getForm.website}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="update-info mt-3">
            <div class="card-dashboard">
                <div class="title-card">
                    <div class="d-flex justify-content-between">
                        <div class="py-10px px-3">Nội dung</div>
                        <div class="btn-update" role="button" @click="updateCheck = 2" v-if="!(this.form.status == 1 && this.form.status_expire === 0)">
                            <i class="icon ion-md-create mr-2"></i>Chỉnh sửa
                        </div>
                    </div>
                </div>
                <div class="body-card-auto p-3">
                    <div class="input-content">
                        <p :class="{
                            'mb-0 fs-14px': true,
                            'see-more-content': true,
                            }" id="content-description" v-html="form.description"></p>
                        <div class="line-text" v-if="seeMore !== 0" @click="btnMore()">
                            <span role="button">{{seeMore === 1 ? 'Xem thêm' : 'Thu gọn'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <updateInfo v-show="updateCheck == 1"
            :active.sync="updateCheck"
            :data="form.detail || form"
            :nation="nation"
            @dataEmit="emitInfo($event)"/>
        <updateContent v-show="updateCheck == 2"
            :active.sync="updateCheck"
            :data="form"
            @dataEmit="emitTitel($event)"/>
        <!-- <updatePicture v-show="updateCheck == 3"
            :data="form"
            :active.sync="updateCheck"/> -->
    </div>
</template>
<script>
import { getToken } from '@/config/token';
import { pictureProductThumb } from '@/config/function';
export default {
    props: ['data'],
    components: {
        updateInfo: () => import('./updateInfo'),
        // updatePicture: () => import('./updatePicture'),
        updateContent: () => import('./updateContent'),
    },
    data(){
        return {
            updateCheck: 0,
            numbUp : 0,
            form: {},
            seeMore: 0,
            previewImg: [],
            nation : [],
            id: this.$route.params.id,
            type: {
                1 : "Chính hãng",
                2 : "Xách tay",
                3 : "Hàng công ty"
            },
            arrPicture : [],
        }
    },
    watch: {
        data: {
            handler(val){
                this.form = val;
            },
            deep: true,
        },
    },
    created() {
        this.form = this.data;
        this.sortImg();
        apiGet('/v2/products/nation').then(res => {
            let data = res.data;
            this.nation = data;
        })
    },
    updated() {
        setTimeout(() => {
            let content = document.getElementById("content-description");
            if(content) {

                if(content.offsetHeight > 250 && this.seeMore !== 2) {
                    this.seeMore = 1;
                }
            }
        }, 100)
    },
    computed : {
        getForm (){
            return this.form.detail || this.form;
        }
    },
    methods: {
        sortImg(){
            if(!this.form.picture) return;
            let img = [];
            this.form.picture.map(item => {
                if(item.name === this.form.detail.picture_main){
                    img.unshift(item);
                }else{
                    img.push(item);
                }
            })
            this.form.picture = img;
        },
        emitInfo(e){
            this.form.detail = {
                name   : e.name,
                price   : this.$formatNumber(e.price),
                type    : e.type,
                min_quality : e.min_quality,
                new     : e.new ? 1 : 0,
                promotion : e.promotion,
                sku     : e.sku,
                quality : e.quality,
                quantity : e.quantity,
                vat : e.vat,
                hot : e.hot,
                origin : e.origin,
                warranty : e.warranty,
                website : e.website,
            }
        },
        emitTitel(e){
            // this.form.detail = {
            //     name   : this.form.detail.name,
            //     price   : this.$formatNumber(this.form.detail.price),
            //     type    : this.form.detail.type,
            //     min_quality : this.form.detail.min_quality,
            //     new     : this.form.detail.new ? 1 : 0,
            //     promotion : this.form.detail.promotion,
            //     quality : this.form.detail.quality,
            //     quantity : this.form.detail.quantity,
            //     vat : this.form.detail.vat,
            //     hot : this.form.detail.hot,
            //     warranty : this.form.detail.warranty,
            //     website : this.form.detail.website,
            // }
            this.form.description = e.description;
        },
        btnMore() {
            if(this.seeMore === 1){
                this.seeMore = 2;
            }else{
                this.seeMore = 1;
            }
        },
        upload(){
            if(this.form.status == 1 && this.form.status_expire === 0){
                this.message();
                return;
            }
            let input = this.$el.querySelector('.input-upload');
            input.click();
        },
        message(){
            this.$message({
                message: 'Vui lòng gian hạn tin',
                type: 'warning',
                center: true,
            })
        },
        changeImage(e){
            let files = e.target.files;
            let id = 10000;
            for(let item of files){
                item.url = URL.createObjectURL(item);
                item.id = id;
                this.previewImg.unshift(item);
                id++;
            }

            this.pushImage();
        },
        destroyPreview(item, index){
            this.files.splice(index, 1);
        },
        destroy(image, index){
            let target = this;
            if(this.form.detail.picture_main == image.name){
                this.$message({
                    message: 'Hãy thay đổi ảnh chính trước khi xóa',
                    type: 'warning',
                    center: true,
                })
            }else{
                this.$confirm('Bạn có chắc chắn xóa ảnh này khỏi tin?', 'Xóa ảnh', {
                    confirmButtonText: 'Đồng ý',
                    cancelButtonText: 'Hủy',
                    type: 'error'
                }).then(res => {
                    let data = [];

                    apiPut(`/v2/profile/product/picture/${this.id}`, {
                        gallery_id: image.id,
                        exclusive : this.form.detail.exclusive,
                    }).then(res => {
                        this.form.picture.map((item, index) => {
                            if(item.id === image.id){
                                this.form.picture.splice(index, 1);
                            }
                        })
                        this.$message({
                            message: 'Xóa ảnh thành công',
                            type: 'success',
                            center: true,
                        })
                 
                       
                    }).catch(err => {
                        this.$message({
                            message: 'Lỗi hệ thống',
                            type: 'error',
                            center: true,
                        })
                    })

                })
            }
                
        },
        async pushImage(){
            let form;
            let dataPutImage = [];
            for(let item of this.previewImg){
                if(item.type == 'image/jpeg' || item.type == 'image/png' || item.type == 'image/jpg'){
                    form = new FormData();
                    form.append('files', item);
                    await apiPost(`https://cdnvg.scandict.com/upload.php`, form).then(async res => {
                        let data = res[0];
                        if(data.success == 1){
                            dataPutImage.unshift(data)
                        }else{
                            this.$message({
                                message: `Upload ảnh ${item.name} bị lỗi`,
                                type: 'error',
                                center: true,
                            })
                        }
                    }).catch(err => {
                        this.$message({
                            type: 'error',
                            message: 'Lỗi hệ thống',
                            center: true,
                        });
                    })
                }
            }
            await this.update(dataPutImage);
            this.previewImg = [];
        },
        async update(image){
            if(image.length == 0) return;
            let data = [];
            image.map(item => {
                data.unshift({
                    name: item.filename,
                    width: item.width,
                    height: item.height
                })
            });

            this.numbUp++;
            await apiPost(`/v2/profile/user_gallery`, {
                images: data,
                pro_id: this.id,
                numb_up: this.numbUp,
                exclusive : this.form.detail.exclusive,
            }).then(res => {
                this.arrPicture.push({
                    id: res.data[0].id,
                });
                res.data.map(item => {
                     this.form.picture.push({
                        id    : item.id,
                        height: item.height,
                        name: item.name,
                        url: item.image_thum,
                        width: item.width
                    })
                });
                this.$message({
                    message: 'Thêm mới ảnh thành công',
                    type: 'success',
                    center: true,
                })
            }).catch(err => {
                this.$message({
                    message: 'Lỗi hệ thống',
                    type: 'error',
                    center: true,
                })
            })
        },
        destroyPreview(id){
            this.previewImg.map((item, index) => {
                if(item.id === id){
                    this.previewImg.splice(index, 1);
                }
            })
            this.form.picture.map((item, index) => {
                if(item.id === id){
                    this.form.picture.splice(index, 1);
                }
            })
        },
        async selectPictureMain(image){
            this.$confirm('Bạn có chắc chắn sử dụng ảnh này làm ảnh chính cho tin này không?', 'Thay đổi ảnh đại diện', {
                confirmButtonText: 'Đồng ý',
                cancelButtonText: 'Hủy',
                type: 'success'
            }).then(async () => {
                this.loadingDestroy = true;
                console.log(image)
                await apiPut(`/v2/profile/product/${this.id}`, {
                    picture: image.name,
                }).then(res => {
                    if(res.success == 1){
                        this.form.detail.picture_main = image.name;
                        this.sortImg();
                    }else{
                        this.$message({
                            message: 'Lỗi hệ thống',
                            type: 'error',
                            center: true,
                        })
                    }
                }).catch(err => {})
                this.loadingDestroy = false;
            }).catch(() => {});
        }
    },
}
</script>
<style lang="scss">
    .update-web {
        .card-dashboard {
            box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
            background: #fff;
            border-radius: 5px;
            .title-card {
                border-bottom: 1px solid #0c81f6;
                .btn-update {
                    color:#007bff;
                    font-size: 14px;
                    padding: 11px 16px;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
            .body-card-auto {
                .info-post {
                    .w-title {
                        width: 150px;
                        color: #666;
                    }
                    .w-value {
                        width: calc( 100% - 150px );
                        .btn_rdo{
                            display: inline-block;
                            background: #CCC;
                            border-radius: 3px;
                            color: #FFF;
                            height: 20px;
                            line-height: 19px;
                            opacity: 1;
                            text-align: center;
                            width: 70px;
                            border: 1px solid #CCC;
                            transition: 0.3s all;
                            box-sizing: border-box;
                            position: relative;
                            font-weight: bold;
                            margin-top: 0;
                            font-size: 10px;
                            &.btn_rdo_buy{
                                background: #F44F00;
                                border: 1px solid #F44F00;
                            }
                            &.btn_rdo_call{
                                background: #33a837;
                                border: 1px solid #33a837;
                            }
                        }
                    }
                }
                .title-post {
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .info-picture {
                    height: 380px;
                    overflow: auto;
                    .img {
                        width: 20%;
                        height: 110px;
                        padding: 16px 8px 0;
                        &:hover {
                            .delete-img {
                                display: block !important;
                            }
                        }
                        img {
                            box-shadow: 0 4px 6px rgba(50,50,93,.11),0 1px 3px rgba(0,0,0,.08);
                            object-fit: cover;
                            border-radius: 4px;
                        }
                        .delete-img {
                            background: rgba(189, 195, 199,0.8);
                            top: 16px;
                            right: 8px;
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            text-align: center;
                            border-radius: 0 4px 0 0;
                            display: none;
                            i {
                                font-size: 20px;
                                color: #fff;
                            }
                        }
                    }
                    .upload-img {
                        width: 20%;
                        height: 110px;
                        padding: 16px 8px 0;
                        .btn-upload {
                            border-radius: 4px;
                            border: 2px dashed rgba(0,0,0,0.2);
                            height: 100%;
                            padding: 10px 0px;
                            i {
                                font-size: 30px;
                                color: #666;
                            }
                            p {
                                color: #666;
                            }
                        }
                    }
                    .checked-img {
                        bottom: 0;
                        width: calc(100% - 16px);
                        background: rgba(40, 167, 69, 0.8);
                        border-radius: 0 0 4px 4px;
                        .btn-check {
                            color: #fff;
                        }
                    }
                    .loading-img {
                        top: 16px;
                        width: 119px;
                        height: 100px;
                        background: rgba(255, 255, 255, 0.8);
                        left: 0;
                    }
                }
                .info-post {
                    height: 380px;
                    overflow: auto;
                }
                .name-category {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        .noti-picture {
            padding: 11px 16px;
        }
        .see-more-content {
            max-height: 250px;
            overflow: hidden;
        }
        .line-text {
            text-align: center;
            position: relative;
        }

        .line-text:before {
            content: "";
            width: 100%;
            height: 1px;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            background-color: #ccc;
        }

        .line-text span {
            display: inline-block;
            background-color: white;
            position: relative;
            padding: 1rem;
            font-weight: 600;
        }
        .action-detail {
            .btn-action-update {
                width: 150px;
            }
        }
    }
    .update-mobile {
        .row {
            margin: 0 !important;
        }
        .info-picture {
            height: unset !important;
            .img {
                width: 100px !important;
                padding: 0 !important;
                height: 100px !important;
                margin: 0 8px;
                img {
                    width: 100px !important;
                    height: 100px !important;
                }
                .delete-img {
                    display: block !important;
                    top: 0 !important;
                    right: 0 !important;
                }
            }
            .img-flex {
                overflow-y: hidden;
                overflow-x: auto;
            }
            .upload-img {
                width: 100px !important;
                height: 100px !important;
                padding: 0 !important;
                margin: 0 8px;
                .btn-upload {
                    width: 100px !important;
                    height: 100px !important;
                }
            }
            .checked-img {
                width: 100% !important;
            }
        }
        .info-post {
            height: unset !important;
            .w-title {
                width: 100px !important;
            }
            .w-value {
                width: calc( 100% - 100px ) !important;
            }
        }
        .loading-img {
            top: 0 !important;
            left: 0;
            width: 100px !important;
        }
        .update-info {
            margin-top: 0 !important;
        }
        .card-dashboard {
            box-shadow: none;
            .title-card {
                border-top: 1px solid #0c81f6;
            }
        }
    }
    .input-content {
        img {
            max-width: 100% !important;
        }
    }
    input {
        -webkit-appearance: auto!important;
    }
</style>
